import React, { FunctionComponent } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { TableBody as MUITableBody } from "@material-ui/core";
import PhoneNumberRow from "./PhoneNumberRow";

interface Props {
  twilioPhoneNumber?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {},
  })
);

export const TableBody: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return (
    <MUITableBody className={classes.container}>
      {props.twilioPhoneNumber && (
        <PhoneNumberRow phoneNumber={props.twilioPhoneNumber} />
      )}
    </MUITableBody>
  );
};

export default TableBody;
